export enum TreezColor {
    BLUE_INFO = 'blueInfo',
    ERROR_RED = 'errorRed',
    GRAPE = 'grape',
    GREEN_LIGHT = 'greenLight',
    GREEN_HIGHLIGHT = 'greenHighlight',
    GREY_DARK = 'greyDark',
    GREY_LIGHT = 'greyLight',
    GREY_MEDIUM = 'greyMedium',
    OFF_WHITE = 'offWhite',
    TEAL = 'teal',
    TREEZ_GREEN = 'treezGreen',
    WARNING_YELLOW = 'warningYellow',
    WHITE = 'white',
}

const {
    BLUE_INFO,
    ERROR_RED,
    GRAPE,
    GREEN_LIGHT,
    GREEN_HIGHLIGHT,
    GREY_DARK,
    GREY_LIGHT,
    GREY_MEDIUM,
    OFF_WHITE,
    TEAL,
    TREEZ_GREEN,
    WARNING_YELLOW,
    WHITE,
} = TreezColor;

export const treezColorMap: {[value in TreezColor]: string} = {
    [BLUE_INFO]: '#5697de',
    [ERROR_RED]: '#e66d4d',
    [GRAPE]: '#b77be5',
    [GREEN_LIGHT]: '#c1db7e',
    [GREEN_HIGHLIGHT]: '#A1DF82',
    [GREY_DARK]: '#484848',
    [GREY_LIGHT]: '#cfd0d2',
    [GREY_MEDIUM]: '#999999',
    [OFF_WHITE]: '#f6f6f6',
    [TEAL]: '#60b8bf',
    [TREEZ_GREEN]: '#6ebe45',
    [WARNING_YELLOW]: '#fbb137',
    [WHITE]: '#ffffff',
};
